
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import francia from "../../assets/francia.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarFrancia({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar francia fordító</title>
                <meta name='description' content="Ingyenes magyar francia fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar francia fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-francia-fordito" />
            </Helmet>
            <h1>Magyar francia fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A magyar és francia nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={francia} alt="francia zászló"></img>
                </div>

                <p>Íme néhány fő hasonlóság és különbség a magyar és a francia között:</p>

                <h3>Hasonlóságok</h3>



                <p>Kiejtés: Mindkét nyelvnek viszonylag fonetikus a helyesírása, ami azt jelenti, hogy a szavakat általában úgy ejtik ki, ahogy írják. Sajátos fonetikai rendszerük és kiejtési szabályaik azonban eltérőek.</p>



                <h3>Különbségek</h3>

                <h4>Nyelvcsalád</h4>
                <ul>
                    <li><b>Magyar</b>: A magyar finnugor nyelv, az uráli nyelvcsalád része. Nem kapcsolódik szorosan más európai nyelvekhez, és egyedülálló nyelvi örökséggel rendelkezik.</li>
                    <li><b>Francia</b>: A francia egy neo-latin nyelv, az indoeurópai nyelvcsaládba tartozik. Közös felmenőkkel rendelkezik más román nyelvekkel, például a spanyollal, az olaszral és a portugállal.</li>
                </ul>


                <h4>Szójegyzék</h4>
                <ul>
                    <li><b>Magyar</b>: A magyar szókincs különálló, és nincs szoros rokonságban más európai nyelvekkel. Néhány szót a szomszédos nyelvekből kölcsönzött, például német, török és szláv nyelvekből.</li>
                    <li><b>Francia</b>: A francia szókincs jelentős hatással van a latinra, és rokon értelmű más román nyelvekkel. A történelem során más nyelvekből is kölcsönzött szavakat, beleértve az angolt is.</li>
                </ul>
                <h4>Nyelvtan</h4>
                <ul>
                    <li><b>Magyar</b>: A magyarnak összetett agglutinatív nyelvtana van. A szótövekhez fűződő toldalékrendszert használja, hogy kifejezze az olyan nyelvtani jellemzőket, mint az idő, a mód, a szám és a birtoklás. Gazdag főnévi esetrendszerrel is rendelkezik a nyelvtani szerepek jelzésére.</li>
                    <li><b>Francia</b>: A francia nyelvtan elemzőbb a magyarhoz képest. Szórendre, elöljárószavakra és névelőkre támaszkodik a nyelvtani kapcsolatok jelzésére. A franciának van egy igeragozási rendszere és sokféle igeidő.</li>
                </ul>


                <h4>Mondatszerkezet</h4>
                <ul>
                    <li><b>Magyar</b>: A magyar nyelvnek van alany-tárgy-ige (SOV) szórendje, ami eltér a legtöbb európai nyelv tipikus szórendjétől. Az ige általában a mondat végére kerül.</li>
                    <li><b>Francia</b>: A francia a alany-ige-tárgy (SVO) szórendet követi, amely a román nyelvcsaládban gyakori.</li>
                </ul>


                <h4>Kiejtés</h4>
                <ul>
                    <li><b>Magyar</b>: A magyar nyelvnek egyszerű hangrendszere van, következetes kiejtési szabályokkal. Ha megtanulja az egyes betűk és betűkombinációk kiejtését, könnyebbé válik a magyar szavak olvasása és kiejtése.</li>
                    <li><b>Francia</b>: A francia nyelvnek egyedi kiejtési rendszere van, különálló magánhangzókkal, összekötőkkel és néma betűkkel. A kiejtés a regionális akcentusoktól függően változhat.</li>
                </ul>
                <div className="sectionbottom">
                    <Link to="/francia-magyar-fordito">Francia magyar fordító</Link>
                    <img src={francia} alt="francia zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarFrancia;